import { useAuth as useAuthContext } from '../../contexts/auth.context.tsx';

export const useAuth = useAuthContext;

export function usePermissions() {
  const { user } = useAuth();

  const hasPermission = (permission: string): boolean => {
    if (!user) return false;
    return user.permissions.includes(permission);
  };

  const hasRole = (role: string): boolean => {
    if (!user) return false;
    return user.roles.includes(role);
  };

  const hasAnyPermission = (permissions: string[]): boolean => {
    if (!user) return false;
    return permissions.some((permission) => user.permissions.includes(permission));
  };

  const hasAnyRole = (roles: string[]): boolean => {
    if (!user) return false;
    return roles.some((role) => user.roles.includes(role));
  };

  return {
    hasPermission,
    hasRole,
    hasAnyPermission,
    hasAnyRole,
    permissions: user?.permissions || [],
    roles: user?.roles || [],
  };
}

export function useAuthLoading() {
  const { loading, error, clearError } = useAuth();

  return {
    isLoading: loading,
    hasError: !!error,
    error,
    clearError,
  };
}
